export default __webpack_public_path__ + "static/media/goldProfile.ecdc40cc.svg";